import React from 'react';
import ServiceAreaDetail from '../ServiceAreaDetail';

// Dedicated page component for /service-areas/queens-ny
const QueensPage = () => <ServiceAreaDetail slug="queens-ny" />;

export default QueensPage;
